/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerProject_ProjectJobs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Project Jobs
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, June 27, 2019 - 12:00:28 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      06/27/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    PROJECTJOB_LIST_CONTAINER_LOADED,
    PROJECTJOB_LIST_CONTAINER_UNLOADED,
    PROJECTJOB_LIST_TABLE_LOADED,
    PROJECTJOB_LIST_TABLE_UNLOADED,
    PROJECTJOB_LIST_LOADED,

    PROJECTJOB_SELECT_ROW,
    PROJECTJOB_ADD,
    PROJECTJOB_EDIT,
    PROJECTJOB_DELETE,
    PROJECTJOB_OPEN_WARNING,
    PROJECTJOB_CLOSE_WARNING,
    PROJECTJOB_DELETE_DISABLE,

    PROJECTJOB_OPEN_EDITHISTORY,
    PROJECTJOB_CLOSE_EDITHISTORY,
    PROJECTJOB_UPDATE_VALUE,

    PROJECTJOB_EDIT_CONTAINER_LOADED,
    PROJECTJOB_EDIT_CONTAINER_UNLOADED,
    PROJECTJOB_EDIT_FORM_LOADED,
    PROJECTJOB_EDIT_FORM_UNLOADED,
    PROJECTJOB_EDIT_DATA_LOAD,
    PROJECTJOB_EDIT_CONTAINER_SUBMIT,
    PROJECTJOB_EDIT_CONTAINER_CANCEL,
    PROJECTJOBHISTORY_SELECT_ROW,
} from '../constants/actionTypeProject_ProjectJobs';

const defaultState = {
    refreshList: false,
    danger: false,
    editHistory: false,
    jobid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: '',
    edit_jobhistoryid: 0,
    edit_timestamp: '',
    edit_jobhistorytypeid: '',
    edit_sourceid: 0,
    edit_notes: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case PROJECTJOB_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                projectjobs: action.payload[0] ? action.payload[0].records : null,
                companies: action.payload[1] ? action.payload[1].companies : null
            }
        case PROJECTJOB_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case PROJECTJOB_LIST_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                projectjobs: action.payload[0] ? action.payload[0].records : null
            }
        case PROJECTJOB_SELECT_ROW:
            return {
                ...state,
                jobid: action.id
            }
        case PROJECTJOB_ADD:
            return {
                ...state
            }
        case PROJECTJOB_EDIT:
            return {
                ...state,
                jobid: action.id
            }
        case PROJECTJOB_DELETE:
            return {
                ...state,
                jobid: null
            }
        case PROJECTJOB_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case PROJECTJOB_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case PROJECTJOB_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case PROJECTJOB_OPEN_EDITHISTORY:
            return {
                ...state,
                editHistory: true
            }
        case PROJECTJOB_CLOSE_EDITHISTORY:
            return {
                ...state,
                editHistory: false
            }
        case PROJECTJOB_EDIT_CONTAINER_LOADED:
        case PROJECTJOB_EDIT_DATA_LOAD:
            return {
                ...state,
                jobid: action.payload[0] ? action.payload[0].jobid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                company: action.payload[0] ? action.payload[0].company : '',
                projectid: action.payload[0] ? action.payload[0].projectid : 0,
                tree_projectid: action.payload[0] ? action.payload[0].projectid : 0,
                project: action.payload[0] ? action.payload[0].project : '',
                parentid: action.payload[0] ? action.payload[0].parentid : 0,
                jobtypeid: action.payload[0] ? action.payload[0].jobtypeid : 0,
                jobtype: action.payload[0] ? action.payload[0].jobtype : '',
                guid: action.payload[0] ? action.payload[0].guid : '',
                jobcode: action.payload[0] ? action.payload[0].jobcode : '',
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                sourceid: action.payload[0] ? action.payload[0].sourceid : 0,
                sourceusername: action.payload[0] ? action.payload[0].sourceusername : '',
                sourcefirstname: action.payload[0] ? action.payload[0].sourcefirstname : '',
                sourcelastname: action.payload[0] ? action.payload[0].sourcelastname : '',
                sourceother: action.payload[0] ? action.payload[0].sourceother : '',
                assignedid: action.payload[0] ? action.payload[0].assignedid : 0,
                assignedusername: action.payload[0] ? action.payload[0].assignedusername : '',
                assignedfirstname: action.payload[0] ? action.payload[0].assignedfirstname : '',
                assignedlastname: action.payload[0] ? action.payload[0].assignedlastname : '',
                priorityid: action.payload[0] ? action.payload[0].priorityid : 0,
                priorityscore: action.payload[0] ? action.payload[0].priorityscore : 500,
                severityid: action.payload[0] ? action.payload[0].severityid : 0,
                statusid: action.payload[0] ? action.payload[0].statusid : 0,
                startid: action.payload[0] ? action.payload[0].startid : 0,
                startdate: action.payload[0] ? action.payload[0].startdate : '1900-01-01 00:00:00',
                endid: action.payload[0] ? action.payload[0].endid : 0,
                enddate: action.payload[0] ? action.payload[0].enddate : '1900-01-01 00:00:00',
                deadlineid: action.payload[0] ? action.payload[0].deadlineid : 0,
                deadlinedate: action.payload[0] ? action.payload[0].deadlinedate : '1900-01-01 00:00:00',
                durationest: action.payload[0] ? action.payload[0].durationest : '00:00:00',
                durationact: action.payload[0] ? action.payload[0].durationact : '00:00:00',
                durationsave: action.payload[0] ? action.payload[0].durationsave : '00:00:00',
                percentcomplete: action.payload[0] ? action.payload[0].percentcomplete : 0,
                versionfoundid: action.payload[0] ? action.payload[0].versionfoundid : 0,
                versiontargetid: action.payload[0] ? action.payload[0].versiontargetid : 0,
                versionfixedid: action.payload[0] ? action.payload[0].versionfixedid : 0,
                audituserid: action.payload[0] ? action.payload[0].audituserid : 0,
                auditusername: action.payload[0] ? action.payload[0].auditusername : '',
                auditfirstname: action.payload[0] ? action.payload[0].auditfirstname : '',
                auditlastname: action.payload[0] ? action.payload[0].auditlastname : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case PROJECTJOB_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case PROJECTJOBHISTORY_SELECT_ROW:
            return {
                ...state,
                jobhistoryid: action.id
            }
        case PROJECTJOB_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case PROJECTJOB_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case PROJECTJOB_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case PROJECTJOB_LIST_CONTAINER_UNLOADED:
        case PROJECTJOB_LIST_TABLE_UNLOADED:
        case PROJECTJOB_EDIT_CONTAINER_UNLOADED:
        case PROJECTJOB_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerProject_ProjectJobs.js